import { motion } from 'framer-motion';
import { useCallback } from 'react';
import { LocalTournamentPlace, useGetLocalTournamentPrize } from 'react-easyrocket';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import tournamentWin from 'src/assets/images/tournamentWin.webp';
import { Button } from 'src/components/Buttons/Button';
import { useModalContext } from 'src/hooks/useModalContext';
import { useRoute } from 'src/router/hooks';
import { openChat } from 'src/utils';

export const WinnerTournamentContent = ({
  tournamentName,
  prize
}: {
  tournamentName: string;
  prize: LocalTournamentPlace;
}) => {
  const { t } = useTranslation();
  const { getPrize } = useGetLocalTournamentPrize();
  const { closeModal } = useModalContext();
  const isPhysicalPrize = prize.type === 1;
  const { ROUTE } = useRoute();
  const navigate = useNavigate();

  const handleGetReward = useCallback(() => {
    closeModal();

    if (!prize) return;

    if (isPhysicalPrize) {
      openChat();
      return;
    }

    if (prize?.wager > 0) {
      navigate(ROUTE.ACCOUNT_BONUS.get('bonus-account'));
    }
    if (prize.wager === 0) {
      navigate(ROUTE.ACCOUNT_USER_BALANCE.get('basicHistory'));
    }
  }, [closeModal, prize, navigate, isPhysicalPrize]);

  return (
    <>
      <motion.img
        src={tournamentWin}
        alt={tournamentName}
        className="w-[191px] h-[131px] object-contain"
        initial={{ scale: 0.4 }}
        animate={{ scale: 1 }}
        transition={{
          type: 'spring',
          stiffness: 180,
          damping: 8,
          mass: 0.55
        }}
      />

      <h2 className="first-letter:uppercase text-xl uppercase text-wtm_title leading-[17px] font-bold">
        {t('winnerTournament.congratulations')}!
      </h2>

      <p className="text-center text-wtm_text text-sm font-medium flex flex-col">
        {t('winnerTournament.youWon')}
        <span>{tournamentName}</span>
      </p>

      <p className="flex flex-wrap justify-center text-[32px] font-bold text-wtm_prize text-center">
        {getPrize(prize)}
      </p>
      <Button className="my-0.5 px-10" mode="button-primary" onClick={handleGetReward}>
        {isPhysicalPrize ? t('winnerTournament.contactSupport') : t('winnerTournament.getReward')}
      </Button>
    </>
  );
};
